export const LOWEST_COST_WITHOUT_CAP = 'LOWEST_COST_WITHOUT_CAP';
export const LOWEST_COST_WITH_BID_CAP = 'LOWEST_COST_WITH_BID_CAP';
export const LOWEST_COST_WITH_MIN_ROAS = 'LOWEST_COST_WITH_MIN_ROAS';
export const TARGET_COST = 'TARGET_COST';

export const BIDING_STRATEGY = 'bidingStrategy';
export const AMOUNT = 'amount';
export const BID_AMOUNT = 'bidAmount';
export const DAILY_BUDGET = 'dailyBudget';
export const LIFETIME_BUDGET = 'lifeTimeBudget';
export const MIN_ROAS_BID = 'minRoasBid';
